import { useStyletron, withStyle } from "baseui";
import { Breadcrumbs } from "baseui/breadcrumbs";
import { StyledLink } from "baseui/link";
import { LabelMedium } from "baseui/typography";
import { useGetHierarchyByIdQuery, useGetObjectByIdQuery } from "../../services/objects";

export interface HierarchyBreadcrumpsProps {
    resourceGroupId: string,
    objectId: string,
   onNavigate: (item?: onNavigateArgs) => void,

}
export type onNavigateArgs = {
    id: string,
    resourceGroupId: string
}

const HierarchyBreadcrumps = ({ resourceGroupId, objectId, onNavigate }: HierarchyBreadcrumpsProps) => {
    const [css] = useStyletron();
    const hasOid = objectId !== undefined && objectId !== '';

    const { data: currentObject } = useGetObjectByIdQuery({ id: objectId, resourceGroupId: resourceGroupId}, { skip: !hasOid });
    const { data, isLoading, isSuccess, error } = useGetHierarchyByIdQuery({ objectId: objectId, resourceGroupId: resourceGroupId}, { skip: !hasOid });
    return (
            <Breadcrumbs>
                <span  key={-1} onClick={() => { onNavigate({ id: '', resourceGroupId: '' }) }} className={css({
                    cursor: "pointer"
                })}>
                        { hasOid && <MyLink  animateUnderline >Apps</MyLink> }
                        { !hasOid && "Apps"}
                </span>
                {hasOid && data?.map((item: any, index: number) => {
                    return (
                        <span key={item.id} onClick={() => { onNavigate({ id: item.id, resourceGroupId: item.resourceGroupId } ) }} className={css({
                            cursor: "pointer"
                        })}>
                          <MyLink animateUnderline >{item.description}</MyLink>
                        </span>
                    )
                })}
                {hasOid && <LabelMedium key={99999999999999} display="inline-block">{currentObject?.description}</LabelMedium>}
            </Breadcrumbs>
    )
}

export default HierarchyBreadcrumps;

const MyLink = withStyle(StyledLink, ({ $theme }) => ({
    fontWeight: 'normal',
    fontSize: $theme.typography.ParagraphSmall.fontSize
}));